module.exports = __webpack_public_path__ + "3253b7f4d060e0eeb64eb85d7e56c933.pdf";